import {
  type FlowMedicalNecessityCheckBlock,
  FlowMedicalNecessityCheckBlockSchema,
} from 'flow-schema';

import { MedicalNecessityCheckFormFields } from './FormFields';
import { medicalNecessityCheckDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const medicalNecessityCheckConfig: BlockConfigProps<
  FlowMedicalNecessityCheckBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'medicalNecessityCheck',
  defaultConfig: {
    diagnoses: '',
    insuranceProvider: '',
    procedureCptCodes: '',
    procedureServiceDate: '',
  },
  configFields: {
    schema: FlowMedicalNecessityCheckBlockSchema.shape.config,
    FormFields: MedicalNecessityCheckFormFields,
  },
  documentationMarkdown: medicalNecessityCheckDocumentationMarkdown,
};
